module.exports = __webpack_public_path__ + "static/media/news5.cd843141.jpeg";